// src/pages/purchase-requisition/history-pengajuan/utils/formatters.js

/**
 * Format tanggal menjadi string sesuai format yang diinginkan
 * @param {Date|string} date - Tanggal yang akan diformat
 * @param {string} format - Format yang diinginkan (DD/MM/YYYY, HH:mm:ss, dll)
 * @returns {string} Tanggal yang sudah diformat
 */
export const formatDate = (date, format = 'DD/MM/YYYY') => {
    if (!date) return '-';
    
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    
    const day = d.getDate().toString().padStart(2, '0');
    const month = (d.getMonth() + 1).toString().padStart(2, '0');
    const year = d.getFullYear();
    
    return format
        .replace('DD', day)
        .replace('MM', month)
        .replace('YYYY', year);
};

/**
 * Format waktu menjadi string
 * @param {Date|string} date - Tanggal yang akan diformat
 * @param {string} format - Format yang diinginkan (HH.mm.ss, HH:mm, dll)
 * @returns {string} Waktu yang sudah diformat
 */
export const formatTime = (date, format = 'HH.mm.ss') => {
    if (!date) return '-';
    
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    
    const hours = d.getHours().toString().padStart(2, '0');
    const minutes = d.getMinutes().toString().padStart(2, '0');
    const seconds = d.getSeconds().toString().padStart(2, '0');
    
    return format
        .replace('HH', hours)
        .replace('mm', minutes)
        .replace('ss', seconds);
};

/**
 * Mendapatkan nama hari dalam bahasa Indonesia
 * @param {Date|string} date - Tanggal
 * @returns {string} Nama hari
 */
export const getDayName = (date) => {
    if (!date) return '-';
    
    const d = new Date(date);
    if (isNaN(d.getTime())) return '-';
    
    const days = [
        'Minggu', 'Senin', 'Selasa', 'Rabu', 
        'Kamis', 'Jumat', 'Sabtu'
    ];
    
    return days[d.getDay()];
};

/**
 * Format tanggal dan waktu lengkap (fungsi yang sudah ada)
 * @param {string} timestamp - Timestamp
 * @returns {string} Tanggal dan waktu yang diformat
 */
export const formatDateTime = (timestamp) => {
    if (!timestamp) return '-';
    
    try {
        const date = new Date(timestamp);
        if (isNaN(date.getTime())) return '-';
        
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        
        return `${day}/${month}/${year} ${hours}:${minutes}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return '-';
    }
};